export enum UnsavedDataWarningDialogActions {
    SAVE_AND_PROCEED = 'save and proceed',
    DISCARD_AND_PROCEED = 'discard and proceed',
    DELETE_AND_PROCEED = 'delete and proceed'
}
